import React from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid} from '@material-ui/core';

import {
    EfeButtonPrimary,
    EfeErrorMsg,
    EfeFormSection,
    EfeSignaturePad,
    EfeSupportMessage,
} from 'components';
import {FieldShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {DigitalizedSignatureValues} from 'commons/models';

InnerFormRepresentativeSign.propTypes = {
    signed: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
        .isRequired,
};

function InnerFormRepresentativeSign(
    props: InferPropTypes<
        typeof InnerFormRepresentativeSign.propTypes &
            FormikProps<DigitalizedSignatureValues>
    >
) {
    const {values, errors, fields, isSubmitting, setFieldValue, signed} = props;

    function setSignature(file: string) {
        setFieldValue('signature', file);
    }

    React.useEffect(() => {
        if (values && values.signature) {
            try {
                const file = new File([values.file], 'sign');
                const filePath = {...file};
                filePath.size = file.size;
                filePath.name = file.name;
            } catch (error) {
                console.error(error);
            }
        }
    }, [values]);

    React.useEffect(() => {
        if (signed) {
            setFieldValue('signature', values.signature);
        }
    }, []);
    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            {fields && fields.length > 0 && (
                <Box m={2}>
                    <EfeSupportMessage />
                    <EfeSignaturePad
                        title={''}
                        description={
                            'Ingrese su firma dentro del recuadro a continuaci\u00F3n'
                        }
                        signature={values.signature}
                        setSignature={setSignature}
                        readonly={false}
                    />
                    {errors.signature && (
                        <Box mt={5} ml={5}>
                            <EfeErrorMsg message={errors.signature} />
                        </Box>
                    )}
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
        </Form>
    );
}

export default InnerFormRepresentativeSign;
